const selectClient = () => {
  const client = process.env.REACT_APP_CLIENT;
  return client;
};
export default selectClient;
